import {createNamespacedHelpers} from "vuex";
const {mapState, mapActions, mapGetters, mapMutations} = createNamespacedHelpers('bookmarkMenuStore');

export default function({state = [], mutations = [], getters = [], actions = []}: {state?: string[], mutations?: string[], getters?: string[], actions?: string[]}) {
  const actionsObj = {};
  actions.forEach(action => {
    const s = action.split(':');
    if (s.length > 1) {
      actionsObj[s[0]] = s[1];
    } else {
      actionsObj[action] = action;
    }
  });
  return {
    computed: {
      ...mapState(state),
      ...mapGetters(getters),
    },
    methods: {
      ...mapMutations(mutations),
      ...mapActions(actionsObj),
    },
  }
}